import { GraphCommand } from "./interfaces/config";
import produce from "immer";
import { plotConfigError, plotDataMissingValueError } from "./errors";
import { AxisType } from "./interfaces/axis";
import { hexColor } from "./helpers/colorParser";
import { ObjectType } from "./interfaces/object";
export function checkIndexValues(index, yValues, dataset, currentFirstValIndex, currentLastValIndex) {
    let firstValIndex = currentFirstValIndex;
    let lastValIndex = currentLastValIndex;
    for (let j = 0; j < yValues.length; j++) {
        const nameYValues = yValues[j];
        if (typeof dataset[nameYValues][index] !== "undefined" &&
            dataset[nameYValues][index] !== null &&
            currentFirstValIndex === null) {
            firstValIndex = index;
        }
        let backIndex = dataset[nameYValues].length - index;
        backIndex = index === 0 ? backIndex - 1 : backIndex;
        if (typeof dataset[nameYValues][backIndex] !== "undefined" &&
            dataset[nameYValues][backIndex] !== null &&
            currentLastValIndex === null) {
            lastValIndex = backIndex;
        }
    }
    return { firstValIndex, lastValIndex };
}
export function getLimitIndexes(xValue, yValues, dataset) {
    let firstValIndex = null;
    let lastValIndex = null;
    if (dataset[xValue]) {
        for (let i = 0; i < dataset[xValue].length &&
            !(firstValIndex !== null && lastValIndex !== null); i++) {
            let indexes = checkIndexValues(i, yValues, dataset, firstValIndex, lastValIndex);
            firstValIndex = indexes.firstValIndex;
            lastValIndex = indexes.lastValIndex;
        }
    }
    lastValIndex = lastValIndex === null ? firstValIndex : lastValIndex;
    return { firstValIndex, lastValIndex };
}
export const getIsAnyY2Visible = (visibleValues, elements) => {
    if (!visibleValues) {
        return false;
    }
    const currentVisibleValues = Object.keys(visibleValues).filter((key) => visibleValues[key]);
    const elementsWithY2 = elements.filter((element) => currentVisibleValues.includes(`${element.colY2}-${element.file}`));
    return elementsWithY2.length > 0;
};
export const getElementXId = (el, ignoreFile = false) => (el.file !== null && !ignoreFile ? `${el.colX}-${el.file}` : `${el.colX}`);
export const getElementDateId = (el, ignoreFile = false) => el.file !== null && !ignoreFile
    ? `${el.colTime}-${el.file}`
    : `${el.colTime}`;
export const getElementYId = (el, ignoreFile = false) => {
    if (isGrafosElement(el)) {
        const isY2 = !el.colY;
        const colYorColY2Data = isY2 ? el.colY2 : el.colY;
        return el.file !== null && !ignoreFile
            ? `${colYorColY2Data}-${el.file}`
            : `${el.colY}`;
    }
    else {
        return el.file !== null && !ignoreFile
            ? `${el.colY}-${el.file}`
            : `${el.colY}`;
    }
};
export const getElementZId = (el, ignoreFile = false) => (el.file !== null && !ignoreFile ? `${el.colZ}-${el.file}` : `${el.colZ}`);
export function getXGraph(id2Display, selectedTab, plotsConfig) {
    let xGraph;
    if (selectedTab !== "defined") {
        try {
            plotsConfig.customSelectorFolderList.forEach((selector) => selector.selectorList.forEach((display) => {
                if (display.id === id2Display) {
                    display.tabs.forEach((tab) => {
                        tab.graphs.forEach((element) => {
                            xGraph = produce(element, (elementCopy) => {
                                elementCopy.title = display.title;
                                elementCopy.axes[0].title = display.title;
                                elementCopy.axes[1].title = display.title;
                            });
                        });
                    });
                }
            }));
        }
        catch (_a) {
            throw plotConfigError();
        }
    }
    return xGraph;
}
export function getSelectorList(xGraph, ids2Display, selectedTab, plotsConfig) {
    let selectorfolder = [];
    let selectorList = [];
    if (selectedTab === "custom") {
        if (xGraph !== undefined) {
            try {
                selectorfolder = produce(plotsConfig.customSelectorFolderList, (copySelector) => {
                    copySelector.forEach((selector) => selector.selectorList.forEach((display) => {
                        if (ids2Display.includes(display.id)) {
                            display.tabs.forEach((tab) => {
                                tab.graphs.forEach((graph) => {
                                    graph.title = display.title;
                                    graph.axes[0].title = xGraph.axes[0].title;
                                    graph.axes[1].title = display.title;
                                    graph.axes[0].mode = xGraph.axes[0].mode;
                                    graph.elements.forEach((subElement) => {
                                        subElement.colX = xGraph.elements[0].colX;
                                    });
                                });
                            });
                        }
                    }));
                });
            }
            catch (_a) {
                throw plotConfigError();
            }
        }
    }
    else if (selectedTab === "defined" &&
        plotsConfig.selectorFolderList.length > 0) {
        selectorfolder = produce(plotsConfig.selectorFolderList, (copySelector) => {
            return copySelector;
        });
    }
    try {
        selectorfolder.forEach((selector) => {
            selector.selectorList.forEach((display) => {
                selectorList.push(display);
            });
        });
    }
    catch (_b) {
        throw plotConfigError();
    }
    return selectorList;
}
export function getSelectedTabs(ids2Display, xDataId, selectorList, selectedTab) {
    let tabs = [];
    let graphsId = [];
    if (selectorList.length > 0) {
        if (selectedTab === "custom") {
            try {
                selectorList.forEach((display) => {
                    if (ids2Display.includes(display.id)) {
                        display.tabs.forEach((tab) => {
                            tabs.push(tab);
                            tab.graphs.map((graph) => {
                                graphsId.push(graph.id);
                            });
                        });
                    }
                });
            }
            catch (_a) {
                throw plotConfigError();
            }
        }
        else {
            try {
                selectorList.forEach((display) => {
                    if (ids2Display.includes(display.id)) {
                        display.tabs.forEach((tab) => {
                            tab.graphs.map((graph) => {
                                graphsId.push(graph.id);
                            });
                            tabs.push(tab);
                        });
                    }
                });
            }
            catch (_b) {
                throw plotConfigError();
            }
        }
    }
    if (xDataId !== "" && !graphsId.includes(xDataId)) {
        graphsId.push(xDataId);
    }
    return { tabs, graphsId };
}
export function prepareConfig(plotsConfig) {
    let plotsConfigChecked;
    if (plotsConfig) {
        plotsConfigChecked = produce(plotsConfig, (copyConfig) => {
            copyConfig.customSelectorFolderList.forEach((selector) => {
                selector.selectorList = selector.selectorList.filter((display) => display.title !== "Template");
                selector.selectorList.forEach((display, index) => {
                    if (!display.id || display.id == "") {
                        display.id = "CDISP_" + index.toString();
                    }
                    display.tabs.forEach((tab) => {
                        if (tab.title == "") {
                            tab.title = display.title;
                        }
                    });
                });
                selector.selectorList = selector.selectorList.filter((display) => display.title !== "Template");
            });
            copyConfig.selectorFolderList.forEach((selector) => selector.selectorList.forEach((display, index) => {
                if (!display.id || display.id == "") {
                    display.id = "DISP_" + index.toString();
                }
            }));
            return copyConfig;
        });
    }
    return plotsConfigChecked;
}
export const getAllPregrafosTabs = (preGrafosConfig) => {
    let tabs = [];
    try {
        if (preGrafosConfig.selectorFolderList[0].selectorList.length > 0) {
            preGrafosConfig.selectorFolderList[0].selectorList.map((display) => {
                display.tabs.map((tab) => {
                    tabs.push(tab);
                });
            });
        }
    }
    catch (_a) {
        throw plotConfigError();
    }
    return tabs;
};
export const getSelectedGraph = (config, graphId) => {
    let selectedGraph;
    try {
        config.selectorFolderList[0].selectorList.forEach((display) => {
            display.tabs.forEach((tab) => {
                tab.graphs.forEach((singleGraph) => {
                    if (graphId === singleGraph.id) {
                        selectedGraph = singleGraph;
                    }
                });
            });
        });
    }
    catch (_a) {
        throw plotConfigError();
    }
    return selectedGraph;
};
export const evaluatePregrafosConfig = (config) => {
    let every;
    try {
        if (config.selectorFolderList && config.selectorFolderList.length > 0) {
            every = config.selectorFolderList[0].selectorList.every((display) => {
                if (display && display.tabs.length > 0) {
                    return display.tabs.every((tab) => {
                        if (tab && tab.graphs.length > 0) {
                            return tab.graphs.every((singleGraph) => {
                                if (singleGraph) {
                                    return true;
                                }
                                return false;
                            });
                        }
                        return false;
                    });
                }
                return false;
            });
        }
        return every;
    }
    catch (_a) {
        throw plotConfigError();
    }
};
export const getXYValues = (xArray, yArray) => {
    let prevX;
    const xAxis = [];
    const yAxis = [yArray[0]];
    xArray.forEach((xElement) => {
        if (xElement !== prevX) {
            prevX = xElement;
            xAxis.push(xElement);
        }
    });
    for (let i = 1; i < yArray.length; i++) {
        if (yArray[i] === yAxis[0]) {
            break;
        }
        else {
            yAxis.push(yArray[i]);
        }
    }
    return { xAxisValues: xAxis, yAxisValues: yAxis };
};
export const getMatrix = (xArray, zArray) => {
    let currentXValue = undefined;
    const matrix = [];
    let row = undefined;
    for (let i = 0; i < xArray.length; i++) {
        if (xArray[i] !== currentXValue) {
            if (row) {
                matrix.push(row);
            }
            row = [];
        }
        row.push(zArray[i]);
        currentXValue = xArray[i];
    }
    matrix.push(row);
    return matrix;
};
export const getY0 = (point, slope) => {
    return point.yCoord - slope * point.xCoord;
};
export const getCutPointforX = (value, point, slope) => {
    const yCut = getY0(point, slope) + slope * value;
    return { xCoord: value, yCoord: yCut };
};
export const getCutPointforY = (value, point, slope) => {
    const xCut = (value - getY0(point, slope)) / slope;
    return { xCoord: xCut, yCoord: value };
};
export const isWithinLimits = (axisCoord, axisValues) => {
    return (axisCoord >= axisValues[0] && axisCoord <= axisValues[axisValues.length - 1]);
};
export const getXIntersections = (axisValues, point, slope) => {
    const { xAxisValues, yAxisValues } = axisValues;
    const cutPoints = xAxisValues
        .map((el) => getCutPointforX(el, point, slope))
        .filter((el) => isWithinLimits(el.yCoord, yAxisValues));
    return cutPoints ? cutPoints : [];
};
export const getYIntersections = (axisValues, point, slope) => {
    const { yAxisValues, xAxisValues } = axisValues;
    let cutPoints;
    if (slope !== 0) {
        cutPoints = yAxisValues
            .map((el) => getCutPointforY(el, point, slope))
            .filter((el) => isWithinLimits(el.xCoord, xAxisValues));
    }
    return cutPoints ? cutPoints : [];
};
export const getZ4X = (matrix, axisValues, xIntersections) => {
    const intersectionsPoints = xIntersections.map((singleInter) => {
        const neighbours = getSurroundingPointsFromArray(axisValues.yAxisValues, singleInter.yCoord);
        const indexOfX = axisValues.xAxisValues.indexOf(singleInter.xCoord);
        let zCut;
        if (neighbours) {
            const lowerIndexY = axisValues.yAxisValues.indexOf(neighbours.lower);
            const upperIndexY = axisValues.yAxisValues.indexOf(neighbours.upper);
            const row = matrix[indexOfX];
            const zLower = row[lowerIndexY];
            const zUpper = row[upperIndexY];
            zCut =
                zLower +
                    ((zUpper - zLower) / (neighbours.upper - neighbours.lower)) *
                        (singleInter.yCoord - neighbours.lower);
        }
        else {
            const indexOfY = axisValues.yAxisValues.indexOf(singleInter.yCoord);
            zCut = matrix[indexOfX][indexOfY];
        }
        return Object.assign(Object.assign({}, singleInter), { zCoord: zCut });
    });
    return intersectionsPoints ? intersectionsPoints : [];
};
export const getZ4Y = (matrix, axisValues, yIntersections) => {
    const intersectionsPoints = yIntersections.map((singleInter) => {
        const neighbours = getSurroundingPointsFromArray(axisValues.xAxisValues, singleInter.xCoord);
        const indexOfY = axisValues.yAxisValues.indexOf(singleInter.yCoord);
        let zCut;
        if (neighbours) {
            const lowerIndexX = axisValues.xAxisValues.indexOf(neighbours.lower);
            const upperIndexX = axisValues.xAxisValues.indexOf(neighbours.upper);
            let rowLower, rowUpper;
            rowLower = matrix[lowerIndexX];
            rowUpper = matrix[upperIndexX];
            const zLower = rowLower[indexOfY];
            const zUpper = rowUpper[indexOfY];
            zCut =
                zLower +
                    ((zUpper - zLower) / (neighbours.upper - neighbours.lower)) *
                        (singleInter.xCoord - neighbours.lower);
        }
        else {
            const indexOfX = axisValues.xAxisValues.indexOf(singleInter.xCoord);
            zCut = matrix[indexOfX][indexOfY];
        }
        return Object.assign(Object.assign({}, singleInter), { zCoord: zCut });
    });
    return intersectionsPoints ? intersectionsPoints : [];
};
export const getSurroundingPointsFromArray = (array, coordPoint) => {
    for (let i = 0; i < array.length - 1; i++) {
        if (array[i] < coordPoint && array[i + 1] > coordPoint) {
            return { lower: array[i], upper: array[i + 1] };
        }
    }
    return undefined;
};
export const cutSurface = (surface, data, xValue, yValue, zValue) => {
    if (surface && data && xValue && yValue && zValue) {
        const dataset = data.data;
        const point = { yCoord: surface.pointY, xCoord: surface.pointX };
        const slope = surface.slope;
        const matrix = getMatrix(dataset[xValue], dataset[zValue]);
        const axisValues = getXYValues(dataset[xValue], dataset[yValue]);
        const xIntersections2D = getXIntersections(axisValues, point, slope);
        const yintersections2D = getYIntersections(axisValues, point, slope);
        const xIntersections3D = getZ4X(matrix, axisValues, xIntersections2D);
        const yIntersections3D = getZ4Y(matrix, axisValues, yintersections2D);
        const refPoint = {
            yCoord: getY0(point, slope) + slope * (axisValues.xAxisValues[0] - 1),
            xCoord: axisValues.xAxisValues[0] - 1,
        };
        return sortPointsArraysBasedOnDistanceAlongXYPlane(refPoint, xIntersections3D, yIntersections3D);
    }
    return undefined;
};
export const sortPointsArraysBasedOnDistanceAlongXYPlane = (point, ...pointsArrays) => {
    const sorted = [];
    pointsArrays.forEach((pointsArray) => {
        pointsArray.forEach((el) => {
            const distance = Math.sqrt((el.xCoord - point.xCoord) ** 2 + (el.yCoord - point.yCoord) ** 2);
            sorted.push(Object.assign(Object.assign({}, el), { distance }));
        });
    });
    sorted.sort((a, b) => a.distance - b.distance);
    return sorted;
};
export const getReferenceYValue = (data, axisId) => {
    const dataset = data.data;
    if (axisId && dataset[axisId] && dataset[axisId].length > 0) {
        let mean = dataset[axisId].reduce((a, b) => a + b, 0) / dataset[axisId].length;
        return mean;
    }
    else {
        return 0;
    }
};
export const getObjectsReferenceYValue = (data) => typeof data === "number"
    ? data
    : data.reduce((a, b) => a + b, 0) / data.length;
export const checkGlobalExtend4Axis = (tabConfig, flag) => {
    return tabConfig.graphs.every((singleGraph) => singleGraph.axes[0].mode === flag);
};
const isGrafosElement = (element) => {
    return element.colY2 !== undefined;
};
export const filterVisibleData = (dataset, xValues, elements, visibleValues, ignoreFileName) => {
    var _a;
    let filteredDataset = {};
    let filteredYValues = [];
    let filteredY2Values = [];
    let filteredXValues = [];
    let filteredElements = [];
    let quadtreeMatrix = {};
    if (elements.length > 0 && Object.keys(dataset).length > 0) {
        const xOfElement = getElementXId(elements[0], ignoreFileName);
        const allYValuesWithNoXnull = Object.keys(dataset)
            .filter((key) => visibleValues[key])
            .map((key) => dataset[key])
            .filter((_elementData, index) => { var _a; return ((_a = dataset === null || dataset === void 0 ? void 0 : dataset[xOfElement]) === null || _a === void 0 ? void 0 : _a[index]) !== null; });
        for (let i = 0; i < elements.length; i++) {
            const key = getElementYId(elements[i], ignoreFileName);
            const zKey = getElementZId(elements[i], ignoreFileName);
            const xOfElement = getElementXId(elements[i], ignoreFileName);
            if (visibleValues[key]) {
                const yValuesWithNoXNull = dataset[key].filter((_elementData, index) => dataset[xOfElement][index] !== null);
                const noNullXValues = (_a = dataset[xValues[i]]) === null || _a === void 0 ? void 0 : _a.filter((xValue) => xValue !== null);
                const xValuesWithNoYNull = noNullXValues === null || noNullXValues === void 0 ? void 0 : noNullXValues.filter((_value, index) => {
                    const someHasValue = allYValuesWithNoXnull.some((yValues) => yValues[index] !== null);
                    if (!someHasValue) {
                        yValuesWithNoXNull.splice(index, 1);
                    }
                    return someHasValue;
                });
                if (!(key in filteredDataset)) {
                    filteredDataset[key] = yValuesWithNoXNull;
                }
                if (!(zKey in filteredDataset) && zKey && zKey !== "") {
                    filteredDataset[zKey] = dataset[zKey];
                }
                if (xValues[i] && !(xValues[i] in filteredDataset)) {
                    filteredDataset[xValues[i]] = xValuesWithNoYNull;
                }
                if (!elements[i].colY) {
                    filteredY2Values.push(key);
                }
                else {
                    filteredYValues.push(key);
                }
                if (!elements[i].colY) {
                    filteredY2Values.push(key);
                }
                else {
                    filteredYValues.push(key);
                }
                if (xValues[i]) {
                    filteredXValues.push(xValues[i]);
                }
                if (xValues[i]) {
                    filteredXValues.push(xValues[i]);
                }
                if (filteredDataset[xOfElement] && filteredDataset[key]) {
                    const elementsMatrix = [];
                    filteredDataset[xOfElement].forEach((_pos, index) => elementsMatrix.push([
                        filteredDataset[xOfElement][index],
                        filteredDataset[key][index],
                    ]));
                    quadtreeMatrix[key] = elementsMatrix;
                }
                filteredElements.push(elements[i]);
            }
        }
    }
    return {
        filteredDataset,
        filteredYValues,
        filteredY2Values,
        filteredXValues,
        filteredElements,
        quadtreeMatrix,
    };
};
export const evaluateGraph2Download = (isDialogOpen, graphCommand) => {
    if (isDialogOpen &&
        (graphCommand === GraphCommand.graph ||
            graphCommand === GraphCommand.bar ||
            graphCommand === GraphCommand.cuts ||
            graphCommand === GraphCommand.timegraph)) {
        return true;
    }
    return false;
};
export const getXYCoordsValues = (graph, ignoreFileName) => {
    const xValues = graph.elements.map((el) => getElementXId(el, ignoreFileName));
    const yValues = graph.elements.map((el) => getElementYId(el, ignoreFileName));
    return { xValues, yValues };
};
export const validateInputs = (graph, dataset) => {
    if (typeof graph.elements !== "object") {
        throw plotConfigError();
    }
    if (!dataset.hasOwnProperty("data") || typeof dataset.data !== "object") {
        throw plotDataMissingValueError("data");
    }
};
export const getXYZSurfaceValues = (graph, ignoreFileName) => {
    const xValues = graph.surfaces.map((singleSurface) => getElementXId(singleSurface, ignoreFileName));
    const yValues = graph.surfaces.map((singleSurface) => getElementYId(singleSurface, ignoreFileName));
    const zValues = graph.surfaces.map((singleSurface) => getElementZId(singleSurface, ignoreFileName));
    return { xValues, yValues, zValues };
};
export const getFileNameWithoutExtension = (text) => {
    if (text) {
        const lastIndex = text.lastIndexOf(".");
        return lastIndex === -1 ? text : text.slice(0, lastIndex);
    }
    return undefined;
};
export const getScaledRadius = (xScale, yScale, y2Scale, pixelRadius) => {
    const xReference = xScale.invert(pixelRadius);
    const yReference = yScale.invert(pixelRadius);
    const y2Reference = y2Scale ? y2Scale.invert(pixelRadius) : undefined;
    const distancePerPixelX = Math.abs(xScale.invert(0) - xReference);
    const distancePerPixelY = Math.abs(yScale.invert(0) - yReference);
    const distancePerPixelY2 = y2Reference
        ? Math.abs(y2Scale.invert(0) - y2Reference)
        : undefined;
    return {
        xSearchRadius: distancePerPixelX,
        ySearchRadius: distancePerPixelY,
        y2SearchRadius: distancePerPixelY2,
    };
};
export const buildLegendProperties = (graph, ignoreFileName) => {
    return graph.elements.reduce((acc, el) => {
        acc[getElementYId(el, ignoreFileName)] = {
            title: el.title,
            style: {
                lineStyle: el.lineStyle,
                symbol: el.symbol,
            },
            color: hexColor(el.symbolColor),
            yId: el.colY
                ? graph.axes.find((axis) => axis.type === AxisType.y).title
                : graph.axes.find((axis) => axis.type === AxisType.y2).title,
        };
        return acc;
    }, {});
};
export const buildObjectProperties = (objects) => {
    let filteredObjects = [];
    for (let i = 0; i < objects.length; i++) {
        const obj = objects[i];
        if (obj.title !== "" && obj.type !== ObjectType.text) {
            filteredObjects.push(obj);
        }
    }
    return filteredObjects.reduce((acc, obj) => {
        const title = obj.title;
        const color = obj.color;
        const lineStyle = obj.lineStyle;
        acc[title + color + lineStyle] = {
            title: title,
            lineStyle: lineStyle,
            color: hexColor(color),
        };
        return acc;
    }, {});
};
export const interpolate = (xArr, yArr, xSearched) => {
    if (yArr[xArr.indexOf(xSearched)]) {
        return yArr[xArr.indexOf(xSearched)];
    }
    const xDown = [...xArr].reverse().find((x) => x <= xSearched);
    const xUp = xArr.find((x) => x >= xSearched);
    const yUp = yArr[xArr.indexOf(xDown)];
    const yDown = yArr[xArr.indexOf(xUp)];
    return yUp + ((xSearched - xDown) * (yDown - yUp)) / (xUp - xDown);
};
export const getRealTimeData = (data, element, ignoreFileName, currentTime) => {
    const xKey = "xTimed";
    const yKey = "yTimed";
    return {
        timedData: {
            [xKey]: [
                interpolate(data.data[getElementDateId(element, ignoreFileName)], data.data[getElementXId(element, ignoreFileName)], currentTime),
            ],
            [yKey]: [
                interpolate(data.data[getElementDateId(element, ignoreFileName)], data.data[getElementYId(element, ignoreFileName)], currentTime),
            ],
        },
        xKey,
        yKey,
    };
};
export const getTimesData = (graph, data, visibleValues, ignoreFileName) => {
    const timesDataKeys = Object.keys(data.data).filter((key) => graph.elements.some((element) => visibleValues[getElementYId(element, ignoreFileName)] &&
        getElementDateId(element, ignoreFileName) === key));
    return timesDataKeys.flatMap((key) => data.data[key]);
};
//# sourceMappingURL=utils.js.map